import type {
  WithContext,
  Organization,
  BreadcrumbList,
  LodgingBusiness,
  Product,
  WebSite,
} from 'schema-dts'

export const organizationBaseSpain: WithContext<Organization> = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'EscapadaRural',
  url: 'https://www.escapadarural.com',
  logo: 'https://static.escapadarural.com/images/logo.png',
  sameAs: [
    'https://www.instagram.com/escapadarural/',
    'https://www.tiktok.com/@escapadarural',
    'https://www.linkedin.com/company/escapada-rural',
    'https://www.pinterest.es/escapadarural/',
    'https://twitter.com/escapadarural',
    'https://www.facebook.com/escapadarural/',
    'https://www.youtube.com/@escapadaruralcom',
  ],
}

export const breadcrumbListBase: WithContext<BreadcrumbList> = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [],
}

export const lodgingBusinessBase: WithContext<LodgingBusiness> = {
  '@context': 'https://schema.org',
  '@type': 'LodgingBusiness',
  name: '',
  image: '',
  priceRange: '',
  telephone: '',
  address: {
    '@type': 'PostalAddress',
    name: '',
  },
}

export const productBase: WithContext<Product> = {
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: '',
  description: '',
  image: '',
  sku: '',
  brand: {
    '@type': 'OnlineBusiness',
    name: 'Casas Rurales',
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: 0,
    bestRating: 0,
    ratingCount: 0,
  },
}

export const websiteBase: WithContext<WebSite> = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: 'https://www.escapadarural.com',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate:
        'https://www.escapadarural.com/casas-rurales?q={search_term_string}',
    },
    // @ts-expect-error query-input is not in the schema type but is a valid SearchAction property
    'query-input': 'required name=search_term_string',
  },
}
